import services from "@/http";
export const ActionBuscarEndereco = (context, payload) => {
    return services.cep.buscar({ cep: payload }).then(r => r.data);
};
